<div class="sa-wrap">

  <div class="sa-header">
    <button class="sa-back-btn" (click)="backToList()">← Volver</button>
    <div>
      <h2 class="sa-header__title">Cuentas conectadas</h2>
      <p class="sa-header__sub">Conecta tus redes para poder publicar desde Nectum</p>
    </div>
  </div>

  <div *ngIf="errorMessage" class="sa-error">{{ errorMessage }}</div>

  <div *ngIf="loading" class="sa-loading">
    <div class="sa-spinner"></div>
    <span>Cargando cuentas...</span>
  </div>

  <div *ngIf="!loading" class="sa-grid">
    <div *ngFor="let net of networks" class="sa-card" [style.--accent]="net.color">

      <div class="sa-card__accent"></div>

      <a *ngIf="profileUrl(net.id) as iconUrl; else iconOnly"
         class="sa-card__icon" [style.background]="net.color"
         [href]="iconUrl" target="_blank" rel="noopener noreferrer">{{ net.icon }}</a>
      <ng-template #iconOnly>
        <div class="sa-card__icon" [style.background]="net.color">
          {{ net.icon }}
        </div>
      </ng-template>

      <div class="sa-card__info">
        <a *ngIf="profileUrl(net.id) as url; else nameOnly"
           class="sa-card__name" [href]="url" target="_blank" rel="noopener noreferrer">{{ net.name }}</a>
        <ng-template #nameOnly>
          <div class="sa-card__name">{{ net.name }}</div>
        </ng-template>

        <ng-container *ngIf="getAccountFor(net.id) as account; else notConnected">
          <div class="sa-card__status sa-card__status--connected">
            ✓ Conectado como <strong>{{ account.externalUsername }}</strong>
          </div>
          <div *ngIf="!account.tokenValid" class="sa-card__warning">
            ⚠️ Token expirado — reconecta para seguir publicando.
          </div>
        </ng-container>

        <ng-template #notConnected>
          <div class="sa-card__status sa-card__status--disconnected">Sin conectar</div>
        </ng-template>
      </div>

      <div class="sa-card__actions">
        <ng-container *ngIf="isConnected(net.id); else connectBtn">
          <button class="sa-btn sa-btn--danger"
                  [disabled]="connectingNetwork !== null"
                  (click)="disconnect(getAccountFor(net.id)!)">
            Desconectar
          </button>
        </ng-container>
        <ng-template #connectBtn>
          <div *ngIf="net.id === 'FACEBOOK'" class="sa-page-id-wrap">
            <input type="text"
                   class="sa-page-id-input"
                   [(ngModel)]="facebookPageId"
                   placeholder="Page ID (solo si usas Business Suite)"
                   title="Opcional: introduce tu Facebook Page ID si tu página está gestionada desde Meta Business Suite" />
          </div>
          <button class="sa-btn sa-btn--primary"
                  [disabled]="connectingNetwork !== null"
                  (click)="connect(net.id)">
            {{ connectingNetwork === net.id ? 'Conectando...' : 'Conectar' }}
          </button>
          <button *ngIf="net.id === 'FACEBOOK'"
                  class="sa-btn sa-btn--ghost sa-btn--sm"
                  [disabled]="connectingNetwork !== null"
                  (click)="connectStaticFacebook()">
            o usar token configurado
          </button>
        </ng-template>
      </div>

    </div>
  </div>

  <div class="sa-info">
    <span class="sa-info__icon">ℹ️</span>
    <span>Para conectar una cuenta necesitas que el administrador haya configurado las credenciales de esa red. Si al conectar te sale error, contacta con soporte.</span>
  </div>

</div>
